import styled from 'styled-components';

export const Overlay = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const SideScreen = styled.div`
  position: fixed;
  z-index: 200;
  top: 0;
  right: 0;
  width: 100vw;
  max-width: 500px;
  height: 100vh;
  overflow: hidden;
  background-color: ${({ theme }): string => theme.palette_white};
  display: flex;
  flex-direction: column;
`;
